import Http from "../util/Http";

class MarketingRequestApi {
    static async createRequest(formData) {
        const res = await Http.post("/marketing/request", formData);
        return res || null;
    }
}

export default MarketingRequestApi;
